




















import Vue from "vue";
import Component from "vue-class-component";
import BlogItem from "@/components/blog/item.vue";
import { TimeLineService } from "@/common/api";
import qNotify from "@/common/qNotify";
@Component({
  name: "BlogIndex",
  components: {
    BlogItem,
  },
})
export default class BlogIndex extends Vue {
  articles = [];
  params: any = {
    page: 1,
    perPage: 20,
    groupId: null,
  };

  mounted() {
    this.params.groupId = this.$router.currentRoute.params.groupId;
  }

  public async getList($state) {
    try {
      const result = await TimeLineService.memberGroupInfoTimeline(this.params);
      if (result.data.articles.length > 0) {
        this.params.page += 1;
        this.articles.push.apply(this.articles, result.data.articles);
        $state.loaded();
      } else {
        $state.complete();
      }
    } catch (error) {
      $state.complete();
      if (error.status === 404) {
        return this.$router.push({
          name: "group.notFound",
          params: { groupId: this.params.id },
        });
      } else {
        qNotify.error({
          text: error.body.message,
        });
      }
    }
  }
}
